import { render, staticRenderFns } from "./FieldRepeater.vue?vue&type=template&id=36d869c1&"
import script from "./FieldRepeater.vue?vue&type=script&lang=ts&"
export * from "./FieldRepeater.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports